import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import { FormField, FormikInput } from 'components/UiKit/FormikFields';
import productValidationAlert from 'assets/productValidationAlert.svg';

const ColumnWithFieldsLeft = ({ labelTitles, LabelInputs, divider }) => {
  const [, nameMeta] = useField(LabelInputs.name);
  const nameHasError = Boolean(nameMeta.touched && nameMeta.error);

  return (
    <div className="flex flex-col w-126 min-w-0">
      <div className="flex flex-row">
        <FormField
          label={
            <span className="inline-flex flex-row">
              {labelTitles.name}
              <span className="text-remove">*</span>
            </span>
          }
          htmlFor={LabelInputs.name}
        >
          <FormikInput
            id={LabelInputs.name}
            name={LabelInputs.name}
            invalid={nameHasError}
            suffix={
              <span className="flex w-5 justify-end">
                {nameHasError && <img src={productValidationAlert} alt="" />}
              </span>
            }
          />
        </FormField>
        {divider('w-6')}
        <FormField label={labelTitles.email} htmlFor={LabelInputs.email}>
          <FormikInput id={LabelInputs.email} name={LabelInputs.email} />
        </FormField>
      </div>
      <FormField
        label={labelTitles.addressLineOne}
        htmlFor={LabelInputs.addressLineOne}
      >
        <FormikInput
          id={LabelInputs.addressLineOne}
          name={LabelInputs.addressLineOne}
        />
      </FormField>
      <FormField label={labelTitles.city} htmlFor={LabelInputs.city}>
        <FormikInput id={LabelInputs.city} name={LabelInputs.city} />
      </FormField>
    </div>
  );
};
ColumnWithFieldsLeft.propTypes = {
  labelTitles: PropTypes.shape({
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    addressLineOne: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired
  }).isRequired,
  LabelInputs: PropTypes.shape({
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    addressLineOne: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired
  }).isRequired,
  divider: PropTypes.func.isRequired
};

export default ColumnWithFieldsLeft;
